import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PrintingTemplateFunction  {
    _originalTypeClassName = "zERP.BO.PrintingTemplateFunction";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PrintingTemplateFunction.translate = translateService;
}
this.Arguments = [];
this.Name = null;
this.PrintingTemplateFunctionKey = null;
this._key = this.PrintingTemplateFunctionKey = 0; 
}

static translate: TranslateService;
_key: any;
Name:any;
Arguments:any;
private _PrintingTemplateFunctionKey:any;
get PrintingTemplateFunctionKey(): any {
    return this._PrintingTemplateFunctionKey;
  }
set PrintingTemplateFunctionKey(value: any) {
    this._PrintingTemplateFunctionKey = value;
    this._key = value;
  }
static setArguments = ($this, items) => {
                if (items == null) items = [];
                if ($this.Arguments == null) $this.Arguments = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Arguments.length > 0) {
                    Domain.PrintingTemplateFunction.removeArguments($this, $this.Arguments[0]);
                }

                Domain.PrintingTemplateFunction.addManyArguments($this, copyItems);
            }
static addManyArguments = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.PrintingTemplateFunction.addArguments($this, items[i]);
                }
            }
static addArguments = ($this, item) => {
                if ($this.Arguments == null) $this.Arguments = [];
                if (item == null || $this.Arguments.indexOf(item) > -1) return;
                $this.Arguments.push(item);
}
static addRangeArguments = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.PrintingTemplateFunction.addArguments($this, item));
            }
static removeArguments = ($this, item) => {
                if ($this == null || $this.Arguments == null || $this.Arguments.indexOf(item) === -1) return;
                var _index = $this.Arguments.indexOf(item);
                $this.Arguments.splice(_index, 1);
}
static clearArguments = ($this) => { $this.Arguments = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.PrintingTemplateFunctionKey == null || $this.PrintingTemplateFunctionKey == 0;
            }


}